export const copyTypes = {
  COPY_JOBS_USER: "copyJobsUser",
  COPY_JOBS_ALL: "copyJobsAll"
};

export const copyLabels = {
  "My Copy Jobs": copyTypes.COPY_JOBS_USER,
  "Copy Jobs": copyTypes.COPY_JOBS_ALL
};
